module.exports = __webpack_public_path__ + "assets/wedorewebposition.08f53ef8df1dbc79f32bddd4e473f8d7.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/img/wedorewebposition.png
 ** module id = 378
 ** module chunks = 0
 **/